import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { drawDOM, exportImage, exportPDF } from '@progress/kendo-drawing';
import { saveAs } from "@progress/kendo-file-saver";
import {
  Chart,
  ChartArea,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartTitle, ChartValueAxis,
  ChartValueAxisItem
} from "@progress/kendo-react-charts";
import { Window } from "@progress/kendo-react-dialogs";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import React, { Component, PureComponent } from "react";
import { Dropdown } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import AddToCart from "../Tenant/AddToCart";
import ViewActionRiskDataset from "./ViewActionRiskDataset";
import TextNarrative from "./TextNarrative";
import SkeletonReport from "./SkeletonReport";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";
// Original label content function
const originalLabelContent = (props) => {
  return `${props.dataItem.name} : ${formatNumber(
    Number(props.dataItem.data),
    "##,#.##"
  )}`;
};



// Label content function that checks if we're in export mode
const labelContent = (props) => {
  // Always use the original function to get the text
  // This ensures consistent formatting regardless of export mode
  return `${props.dataItem.name} : ${formatNumber(
    Number(props.dataItem.data),
    "##,#.##"
  )}`;
};
const labelContentYvalue = (props) => {
  return Number(props.value);
};

// Tooltip content function that checks if we're in export mode
const tooltipContent = (props) => {
  // Use the original function to get the value
  const value = labelContentYvalue(props);

  // For Kendo charts, the content function should return the value to display
  return value;
};



export default class PieChartContainer extends Component {
  _chart;
  _MailId;
  _Message;
  _Title;
  _expandFlag;
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      isReportLoaded: false,
      chartData: {},
      seriesColors: [],
      isExportMode:false
    };
    this.closeWidgetDeletePopup = this.closeWidgetDeletePopup.bind(this);
    this.forceChartRefresh = this.forceChartRefresh.bind(this);
  }
  
  componentDidUpdate(prevProps, prevState) {
    // Check if isExportMode changed
    if (prevState.isExportMode !== this.state.isExportMode) {
      console.log("isExportMode changed from", prevState.isExportMode, "to", this.state.isExportMode);
      // Force chart refresh when export mode changes
      this.forceChartRefresh();
    }
  }
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      let seriesColors = this.generateColors(50);

      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
        seriesColors: seriesColors
      });
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        let seriesColors = this.generateColors(50);
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
          seriesColors: seriesColors
        });
        setTimeout(() => {
          this.onPDFExportClick("INIT");
        }, 1000);
        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };

  onImageExportClick = () => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Pie-chart";

    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    if (!gridElement) {
      return;
    }
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    
    // 4. Create a temporary white background overlay
    const whiteBackground = document.createElement('div');
    whiteBackground.style.position = 'absolute';
    whiteBackground.style.top = '0';
    whiteBackground.style.left = '0';
    whiteBackground.style.width = '100%';
    whiteBackground.style.height = '100%';
    whiteBackground.style.backgroundColor = 'white';
    whiteBackground.style.zIndex = '-1';
    
    // Store original position style
    const originalPosition = gridElement.style.position;
    
    // Make the container positioned so the absolute overlay works
    gridElement.style.position = 'relative';
    
    // Add the white background to the container
    gridElement.appendChild(whiteBackground);
    
    // 5. Create a style element with comprehensive white background rules
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Target the specific container */
      #${gridElement.id} {
        background-color: white !important;
        color: black !important;
        position: relative !important;
      }
      
      /* Target all elements inside the container */
      #${gridElement.id} * {
        background-color: white !important;
        color: black !important;
      }
      
      /* Specific targeting for the dataset header which appears to have a black background */
      #${gridElement.id} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target the text narrative area */
      #${gridElement.id} .textnarrativeexport {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .textnarrativeexport p {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target any potential dividers or borders */
      #${gridElement.id} hr,
      #${gridElement.id} .divider {
        background-color: white !important;
        border-color: white !important;
      }
      
      /* Preserve chart colors */
      #${gridElement.id} .mitigated { background-color: rgb(248, 220, 135) !important; }
      #${gridElement.id} .unmitigated { background-color: rgb(255, 138, 130) !important; }
      #${gridElement.id} .mitigatedend { background-color: rgb(255, 210, 70) !important; }
      #${gridElement.id} .umitigatedend { background-color: rgb(255, 99, 88) !important; }
      #${gridElement.id} .originalCompletionDate { background-color: rgb(206,237,248) !important; }
      #${gridElement.id} .projectedCompletionDate { background-color: rgb(227, 241, 22) !important; }
      #${gridElement.id} .actualCompletionDate { background-color: rgb(34,159,204) !important; }
      #${gridElement.id} .currentValue { background-color: rgb(8, 77, 167) !important; }
    `;
    
    // Add the style element to the document head
    document.head.appendChild(styleElement);
    
    // 6. Export immediately
    drawDOM(gridElement, { background: "white" })
      .then((group) => exportImage(group, { background: "white" }))
      .then((dataURI) => {
        saveAs(dataURI, widgetName + ".png");
      })
      .finally(() => {
        // 7. Clean up - remove the white background overlay
        try {
          gridElement.removeChild(whiteBackground);
        } catch (e) {
          console.error("Error removing white background:", e);
        }
        
        // 8. Restore original position
        gridElement.style.position = originalPosition;
        
        // 9. Remove the style element
        try {
          document.head.removeChild(styleElement);
        } catch (e) {
          console.error("Error removing style element:", e);
        }
        
        // 10. Hide the narrative element again
        if (narrativeElement) {
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
  };
  // Force chart to refresh when export mode changes
  forceChartRefresh = () => {
    console.log("Forcing chart refresh, isExportMode:", this.state.isExportMode);
    if (this._chart && typeof this._chart.refresh === "function") {
      console.log("Calling chart refresh method");
      this._chart.refresh();
    }
  };

  onPDFExportClick = async (flag) => {

    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Pie-chart";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    if (!gridElement) {
      return;
    }
    // Find the narrative element (moved outside try/catch for proper scope)
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");
    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }

    // Create a style tag with comprehensive styling for export
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      /* Base styles for the chart container */
      #${gridElement.id} {
        background-color: white !important;
        color: black !important;
      }
      
      /* Chart container layout */
      #${gridElement.id} .pieContainer {
        position: relative;
        padding-left: 60px;
        padding-bottom: 40px;
        background-color: white !important;
      }
       #${gridElement.id} .wgTitle{
       color: black !important;
        padding-left: 60px;
      }
      /* X and Y axis styling - ensure visibility */
      #${gridElement.id} .pieX,
      #${gridElement.id} .pieY {
        color: black !important;
        background-color: white !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      #${gridElement.id} .pieX span,
      #${gridElement.id} .pieY span {
        color: black !important;
        background-color: white !important;
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        
      }
      #${gridElement.id} .pieY {
    text-align: center !important;
    top: 190px;
    padding-top: 10px !important;
    }
      /* Text narrative export styling */
      #${gridElement.id} .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow", sans-serif;
        font-style: normal;
        background-color: white !important;
        padding-left: 47px;
      }
      
      /* Chart element styling */
      #${gridElement.id} .k-chart-surface,
      #${gridElement.id} .k-chart-area,
      #${gridElement.id} .k-chart svg,
      #${gridElement.id} .k-chart-plot-area {
        background-color: white !important;
      }
      
      /* Label styling */
      #${gridElement.id} .k-chart text {
        // fill: black !important;
        color: black !important;
        // visibility: visible !important;
        // opacity: 1 !important;
      }
      
      /* Axis label styling */
      #${gridElement.id} .k-chart .k-axis-title,
      #${gridElement.id} .k-chart .k-axis-labels text {
        // fill: black !important;
        color: black !important;
        // visibility: visible !important;
        // opacity: 1 !important;
        // font-weight: bold !important;
      }
      
      /* Label background styling */
      #${gridElement.id} .k-chart path[fill]:not([fill="none"]) {
        fill: white !important;
      }
      
      /* Force all backgrounds to be white */
      #${gridElement.id} div,
      #${gridElement.id} span,
      #${gridElement.id} h4,
      #${gridElement.id} h5,
      #${gridElement.id} p {
        background-color: white !important;
      }
      
      /* Header styling */
      #${gridElement.id} .wgHeader,
      #${gridElement.id} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        padding-left: 25px;
      }
          /* Preserve chart colors */
      #${gridElement.id} .mitigated { background-color: rgb(248, 220, 135) !important; }
      #${gridElement.id} .unmitigated { background-color: rgb(255, 138, 130) !important; }
      #${gridElement.id} .mitigatedend { background-color: rgb(255, 210, 70) !important; }
      #${gridElement.id} .umitigatedend { background-color: rgb(255, 99, 88) !important; }
      #${gridElement.id} .originalCompletionDate { background-color: rgb(206,237,248) !important; }
      #${gridElement.id} .projectedCompletionDate { background-color: rgb(227, 241, 22) !important; }
      #${gridElement.id} .actualCompletionDate { background-color: rgb(34,159,204) !important; }
      #${gridElement.id} .currentValue { background-color: rgb(8, 77, 167) !important; }
    `;
    document.head.appendChild(styleTag);

    drawDOM(gridElement, {
      title: this.state.title + " " + CreatedDate,
      background: "white",
    })
      .then((group) => {
        return exportPDF(group, {
          background: "white"
        });
      })
      .then((dataURI) => {
        console.log("PDF generated successfully");
        if (flag === "MAIL") {
          this.sendMail(dataURI, chartId);
        } else if (flag !== "INIT") {
          saveAs(dataURI, widgetName + ".pdf");
        }
      })
      .catch((error) => {
        console.error("PDF export error:", error);

      })
      .finally(() => {
        // Clean up - remove the style tag
        console.log("Cleaning up export resources");
        try {
          document.head.removeChild(styleTag);
        } catch (e) {
          console.error("Error removing style tag:", e);
        }

        // Refresh the chart to restore original styles
        if (this._chart && typeof this._chart.refresh === "function") {
          try {
            this._chart.refresh();
          } catch (e) {
            console.error("Error refreshing chart:", e);
          }
        }


        if (narrativeElement) {
          // 5. After export, remove the temporary text or hide the element
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
  };
  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId || this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  changeLineChartWidth = (widgetId) => {
    this._expandFlag = true;
    this.props.changeLineChartWidth(widgetId);
  };
  editWidget = (data) => {
    if (data.isActionWidget) {
      this.refs.childWidget.editWidgetdOpen("MITI", data);
    } else {
      this.refs.childWidget.editWidgetdOpen("RISK", data);
    }
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile = (widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");

    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    setTimeout(async () => {
      drawDOM(gridElement, {
        landscape: true,
        title: this.state.title + " " + CreatedDate,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataURI) => {
          this.sendMail(dataURI, widgetId);
        });
    }, 2000);
  };

  sendMail = async (dataURL, widgetId) => {
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Bar-chart";
    var blob = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    var fd = new FormData(document.forms[0]);
    fd.append("file", blob);
    fd.append("mailId", this._MailId);
    fd.append("message", this._Message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this._MailId = "";
      this._Message = "";
      this.setState({ ...this.state, loader: false });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 2000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };

  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };
  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };
  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
  handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    console.log("handleChartRefresh called, isExportMode:", this.state.isExportMode);
    
    if (!this.state.isReportLoaded) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
    if (this._expandFlag === true) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
    
    // If we're in export mode, make sure the chart reflects the export styling
    if (this.state.isExportMode) {
      console.log("Applying export mode styling in handleChartRefresh");
      
      // Make a deep copy of the options
      const exportOptions = JSON.parse(JSON.stringify(chartOptions));
      
      // Modify the options for export
      if (exportOptions.series && Array.isArray(exportOptions.series)) {
        exportOptions.series.forEach(series => {
          if (series.type === 'pie' || !series.type) {
            // Store original settings if needed
            if (!series._originalLabels) {
              series._originalLabels = JSON.parse(JSON.stringify(series.labels || {}));
            }
            
            // Set export-specific label options but preserve the content function
            series.labels = {
              ...series.labels,
              background: "white",
              color: "black",
              // border: {
              //   color: "black",
              //   width: 1
              // },
              // Ensure the content function is preserved
              content: labelContent
            };
          }
        });
      }
      
      // Apply the modified options
      chartInstance.setOptions(exportOptions, themeOptions);
    }
  };
  // Function to generate distinct HSL-based colors
  generateColors = (count) => {
    const baseColors = [
      "#e6194b", "#3cb44b", "#ffe119", "#4363d8", "#f58231", "#911eb4", "#46f0f0",
      "#f032e6", "#bcf60c", "#fabebe", "#008080", "#e6beff", "#9a6324", "#fffac8",
      "#800000", "#aaffc3", "#808000", "#ffd8b1", "#000075", "#808080", "#ffffff", "#000000"
    ];

    const palette = [];
    for (let i = 0; i < count; i++) {
      const color = baseColors[i % baseColors.length];
      palette.push(color);
    }

    return palette;
  };
  editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    console.log("PieChart render", this.props.overAllDownlad);
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    const startDate = moment(chartData.startDate).format("DD-MMM-yyyy");
    const endDate = moment(chartData.endDate).format("DD-MMM-yyyy");
    const toTitleCaseXName = chartData?.xName?.replace(
      /(^\w|\s\w)(\S*)/g,
      (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
    );
    const toTitleCaseYName = chartData?.yName?.replace(
      /(^\w|\s\w)(\S*)/g,
      (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
    );
const key =`${this.state.isExportMode}-${this.props.overAllDownlad}`;
console.log("key",key);
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else if (
      (chartData.yAxes == "PreWeightedRiskScore" ||
        chartData.yAxes == "Prime Risk Score") &&
      (chartData.isPrimeWorkstreams == false ||
        secureLocalStorage.getItem("isPrime") === false)
    ) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>

          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for Tenant or
            Workstream. Please contact administrator.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.isCustomFieldDeleted || chartData.isImpactDeleted) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>
          <h4 className="wgTitle">
            Associated Dataset's Impact/Custom fields might been deleted or
            revoked
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.notValidPrimeDataset) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>
          <h4 className="wgTitle">
            Cannot load report as Prime settings have been changed for
            Workstream.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else if (chartData.isTaskModuleDisabled) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>
          <h4 className="wgTitle">
            Cannot load report as Task Module settings have been changed for
            Tenant. Please contact administrator.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else {
      if (chartData.timeStamp && chartData.ndf) {
        return (
          <div>
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
                : ""}
            </ul>
            <h4 className="wgTitle">No Data Found</h4>

            <Popup
              show={this.state.openDeleteModelFlag}
              popupClass={"popup-content"}
            >
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="deleteModelCont">
                <h3>Are you sure you want to delete this report?</h3>
                <div className="btnCont">
                  <button
                    onClick={() => this.removeWidget(chartData)}
                    className="deleteBtn"
                    type="button"
                  >
                    Yes
                  </button>
                  <button
                    onClick={this.closeWidgetDeletePopup}
                    className="cancelBtn"
                    type="button"
                  >
                    No
                  </button>
                </div>
              </div>
            </Popup>
          </div>
        );
      } else if (
        chartData.timeStampPieChartResponses &&
        chartData.timeStampPieChartResponses.timeStampPieCurrentDate &&
        chartData.timeStampPieChartResponses.timeStampPieCurrentDate.length ==
        0 &&
        chartData.timeStampPieChartResponses.timeStampPiePreDate &&
        chartData.timeStampPieChartResponses.timeStampPiePreDate.length == 0
      ) {
        return (
          <div id="capture">
            {this.state.visible && (
              <Window
                title={chartData.dataSource}
                onClose={this.closeToggleClose}
                className="statusWindow"
                initialLeft={350}
                initialTop={200}
                initialWidth={1000}
                initialHeight={490}
              // maxHeight={490}
              >
                <div className="tblCont dataGrids">
                  <ViewActionRiskDataset
                    chartData={chartData}
                    isFreezeDS={this.props.isFreezeDS}
                  ></ViewActionRiskDataset>
                </div>
              </Window>
            )}
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
                : ""}
            </ul>
            <h4 className="wgTitle">No Data Found</h4>

            <Popup
              show={this.state.openDeleteModelFlag}
              popupClass={"popup-content"}
            >
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="deleteModelCont">
                <h3>Are you sure you want to delete this report?</h3>
                <div className="btnCont">
                  <button
                    onClick={() => this.removeWidget(chartData)}
                    className="deleteBtn"
                    type="button"
                  >
                    Yes
                  </button>
                  <button
                    onClick={this.closeWidgetDeletePopup}
                    className="cancelBtn"
                    type="button"
                  >
                    No
                  </button>
                </div>
              </div>
            </Popup>
          </div>
        );
      } else {
        return (
          <div style={{ minwidth: "500px" }} id="capture">
            {this.state.visible && (
              <Window
                title={chartData.dataSource}
                onClose={this.closeToggleClose}
                className="statusWindow"
                initialLeft={350}
                initialTop={200}
                initialWidth={1000}
                initialHeight={490}
              >
                <div className="tblCont dataGrids">
                  <ViewActionRiskDataset
                    chartData={chartData}
                  ></ViewActionRiskDataset>
                </div>
              </Window>
            )}
            {this.props.expandIcon && (
              <div className="expandView">
                <a
                  className="expand"
                  onClick={() => this.changeLineChartWidth(chartData.widgetId)}
                >
                  <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
                </a>
                <a
                  className="shrink"
                  onClick={() => this.changeLineChartWidth(chartData.widgetId)}
                >
                  <img src={Images.SHRINK} alt="Expand" width="10" />
                </a>
              </div>
            )}
            {this.props.viewDataSetIcon && (
              <ul className="viewDataset WidgetActions">
                <TextNarrative
                  chartInputs={chartData}
                  refreshTextNarative={this.refreshTextNarative}
                  isFreezeDS={this.props.isFreezeDS}
                />
                <li
                  title="View Dataset"
                  onClick={() => this.ViewDataSet(chartData)}
                >
                  <a>
                    <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                  </a>
                </li>
              </ul>
            )}
            {this.props.flag ? (
              <ul className="WidgetActions">
                {this.props.isTenentAdmin ||
                  chartData.createdBy == userId ||
                  (this.props.selectedDashboard &&
                    this.props.selectedDashboard.createdBy == userId)
                  ? !this.props.isFreezeDS && (
                    <li onClick={() => this.editWidgetOpen(chartData)}>
                      <a>
                        <img src={Images.EDITICON} alt="Edit" width="14" />
                      </a>
                    </li>
                  )
                  : ""}
                <TextNarrative
                  chartInputs={chartData}
                  refreshTextNarative={this.refreshTextNarative}
                  isFreezeDS={this.props.isFreezeDS}
                />
                <li
                  title="View Dataset"
                  onClick={() => this.ViewDataSet(chartData)}
                >
                  <a>
                    <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                  </a>
                </li>
                {this.props.isFreezeDS ? (
                  ""
                ) : (
                  <li
                    title="Add to home"
                    onClick={() => this.moveToHome(chartData)}
                  >
                    <a>
                      <img src={Images.HOME} alt="Download" width="14" />
                    </a>
                  </li>
                )}

                <li title="PNG Download" onClick={this.onImageExportClick}>
                  <a>
                    <img src={Images.DOWNLOAD} alt="Download" width="14" />
                  </a>
                </li>
                <li title="PDF Download" onClick={this.onPDFExportClick}>
                  <a>
                    <img src={Images.PDF} alt="Download" width="14" />
                  </a>
                </li>
                {this.props.isFreezeDS ? (
                  ""
                ) : (
                  <li
                    title="Share"
                    onClick={() => this.openAddToCart(chartData.widgetId)}
                  >
                    <a>
                      <img src={Images.SHARE} alt="Download" width="14" />
                    </a>
                  </li>
                )}
                <li>
                  <Dropdown
                    menuAlign="right"
                    title="Mail"
                    id="dropdown-menu-align-right"
                  >
                    <Dropdown.Toggle>
                      <a>
                        <img src={Images.MAIL} alt="Share" width="14" />
                      </a>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="filterList emailBox">
                      <div className="filterBox">
                        <div className="dateRange">
                          <div className="dateCont">
                            <h6>Email</h6>
                            <input
                              type="email"
                              autoComplete="off"
                              onChange={(e) => (this._MailId = e.target.value)}
                            />
                          </div>
                          <div className="dateCont">
                            <h6>Message</h6>
                            <textarea
                              // value={this.state.message}
                              autoComplete="off"
                              onChange={(e) => (this._Message = e.target.value)}
                            ></textarea>
                            <Dropdown.Item
                              as="button"
                              onClick={() => this.onPDFExportClick("MAIL")}
                            >
                              SEND
                            </Dropdown.Item>
                          </div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                {this.props.isTenentAdmin ||
                  chartData.createdBy == userId ||
                  (this.props.selectedDashboard &&
                    this.props.selectedDashboard.createdBy == userId)
                  ? !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                  : ""}
              </ul>
            ) : (
              <ul className="WidgetActions">
                {/* <li title="Remove from home" onClick={() => this.removeFromHome(chartData)}>
                <a>
                  <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
                </a>
              </li> */}
              </ul>
            )}
            <div id={"c" + chartData.widgetId} key={chartData.title}>

              {chartData.timeStamp && chartData.timeStampPieChartResponses ? (
                <div key={key}>
                  <div className="doublePie" >
                    {chartData.ndF2 ? (
                      <div>
                        <h4 className="wgTitle">No Data Found</h4>
                      </div>
                    ) : (
                      <div className="pieContainer" 
                      
                      >
                        <div className="pieX">
                          <span> {toTitleCaseXName}</span>
                        </div>
                        <div className="pieY">
                          <span>{toTitleCaseYName}</span>
                        </div>
                        <Chart
                          title=""
                          style={{ width: "100%" }}
                          ref={(emp) => (this._chart = emp)}
                          onRefresh={this.handleChartRefresh}
                          seriesColors={this.state.seriesColors}
                        >
                          <ChartTitle
                            text={chartData.title ? chartData.title : ""}
                            color="#b5b5b5"
                          />

                          <ChartArea
                            background="transparent"
                            margin={(0, 20)}
                          />
                          <ChartLegend position="bottom" visible={false} />
                          <ChartSeries>
                            <ChartSeriesItem
                              type="pie"
                              data={
                                chartData.timeStampPieChartResponses
                                  ? chartData.timeStampPieChartResponses
                                    .timeStampPiePreDate
                                  : []
                              }
                              field="data"
                              categoryField="name"
                              tooltip={{
                                visible: true,
                                content: tooltipContent
                              }}
                              labels={{
                                visible: true,
                                content: labelContent,
                                color:"#b5b5b5",
                                background: "none",//this.state.isExportMode ? "white" : "black",
                                // color: this.state.isExportMode || this.props.overAllDownlad ? "black" : "white",
                                padding: 3,
                                // border: {
                                //   color: this.state.isExportMode ? "white" : "black",
                                //   width: 1
                                // }
                              }}
                            // labels={{ visible: true, content: labelContent }}
                            ></ChartSeriesItem>
                          </ChartSeries>
                          <ChartValueAxis skip={4}>
                            <ChartValueAxisItem
                              color="#919191"
                              skip={2}
                              title={{ text: chartData.yName }}
                            />
                          </ChartValueAxis>
                        </Chart>
                      </div>
                    )}

                    <h5 className="wgTitle">Snapshot 1 : {startDate}</h5>
                    {chartData.ndF1 ? (
                      <div>
                        <br></br>
                        <br></br>
                        <h4 className="wgTitle">No Data Found</h4>
                      </div>
                    ) : (
                      <div className="pieContainer" >
                        <div className="pieX">
                          <span> {toTitleCaseXName}</span>
                        </div>
                        <div className="pieY">
                          <span>{toTitleCaseYName}</span>
                        </div>
                        <Chart
                          title=""
                          style={{ width: "100%" }}
                          ref={(emp) => (this._chart = emp)}
                          onRefresh={this.handleChartRefresh}
                          seriesColors={this.state.seriesColors}
                        >
                          <ChartTitle
                            text={chartData.title ? chartData.title : ""}
                            color="#b5b5b5"
                          />
                          <ChartArea
                            background="transparent"
                            margin={(0, 20)}
                          />
                          <ChartLegend position="bottom" visible={false} />
                          <ChartSeries>
                            <ChartSeriesItem
                              type="pie"
                              data={
                                chartData.timeStampPieChartResponses
                                  ? chartData.timeStampPieChartResponses
                                    .timeStampPieCurrentDate
                                  : []
                              }
                              field="data"
                              categoryField="name"
                              tooltip={{
                                visible: true,
                                content: tooltipContent
                              }}
                              labels={{
                                
                                visible: true,
                                content: labelContent,
                                color:"#b5b5b5",
                                background: "none",//this.state.isExportMode ? "white" : "black", 
                                // color: this.state.isExportMode || this.props.overAllDownlad ? "black" : "white",
                                padding: 3,
                                // border: {
                                //   color: this.state.isExportMode ? "white" : "black",
                                //   width: 1
                                // }
                              }}
                            // labels={{ visible: true, content: labelContent }}
                            ></ChartSeriesItem>
                          </ChartSeries>
                          <ChartValueAxis skip={4}>
                            <ChartValueAxisItem
                              color="#919191"
                              skip={2}
                              title={{ text: chartData.yName }}
                            />
                          </ChartValueAxis>
                        </Chart>
                      </div>
                    )}
                  </div>

                  <h5 className="wgTitle">Snapshot 2 : {endDate}</h5>
                </div>
              ) : (
                <div className="pieContainer" key={key}>
                  <div className="pieX">
                    <span>{toTitleCaseXName}</span>
                  </div>
                  <div className="pieY">
                    <span>{toTitleCaseYName}</span>
                  </div>
                  <Chart
                    title=""
                    style={{ width: "100%" }}
                    ref={(emp) => (this._chart = emp)}
                    onRefresh={this.handleChartRefresh}
                    seriesColors={this.state.seriesColors}
                  >
                    <ChartTitle
                      text={chartData.title ? chartData.title : ""}
                      color="#b5b5b5"
                    />
                    <ChartArea background="transparent" margin={(0, 20)} />
                    <ChartLegend position="bottom" visible={false} />
                    <ChartSeries>
                      <ChartSeriesItem
                        type="pie"
                        data={chartData.chartResponse}
                        field="data"
                        categoryField="name"
                        tooltip={{
                          visible: true,
                          content: tooltipContent
                        }}
                        labels={{
                          visible: true,
                          content: labelContent,
                          color:"#b5b5b5",
                          background: "none",//this.state.isExportMode ? "white" : "black",
                          // color: this.state.isExportMode || this.props.overAllDownlad ? "black" : "white",
                          padding: 3,
                          // border: {
                          //   color: this.state.isExportMode ? "white" : "black",
                          //   width: 1
                          // }
                        }}
                      ></ChartSeriesItem>
                    </ChartSeries>
                    <ChartValueAxis skip={4}>
                      <ChartValueAxisItem
                        color="#919191"
                        skip={2}
                        title={{ text: chartData.yName }}
                      />
                    </ChartValueAxis>
                  </Chart>
                </div>
              )}
              <div className="wgHeader">
                <h4>Dataset: {chartData.dataSource} </h4>
              </div>
              <TextNarrativeExport
                chartData={chartData}
                isHidden={this.state.isHidden}
              />
            </div>
            <ReportUpdate
              chartData={chartData}
              ref="childUpdateWidget"
              updateChartData={this.updateChartData}
            />
            <Popup
              show={this.state.openDeleteModelFlag}
              popupClass={"popup-content"}
            >
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="deleteModelCont">
                <h3>Are you sure you want to delete this report?</h3>
                <div className="btnCont">
                  <button
                    onClick={() => this.removeWidget(chartData)}
                    className="deleteBtn"
                    type="button"
                  >
                    Yes
                  </button>
                  <button
                    onClick={this.closeWidgetDeletePopup}
                    className="cancelBtn"
                    type="button"
                  >
                    No
                  </button>
                </div>
              </div>
            </Popup>

            <Popup
              show={this.state.openPdfTitlePopup}
              popupClass={"popup-content"}
            >
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}

              <div className="addTypeForm">
                <div className="fieldCont">
                  <label>Enter Title</label>
                  <input
                    type="text"
                    onChange={(e) => this.setState({ title: e.target.value })}
                    placeholder="Title"
                    value={this.state.title}
                    required
                  />
                </div>
                <div className="btnGroup">
                  <button
                    disabled={!this.state.title}
                    className="btnPrimary"
                    onClick={this.onPDFExportClick}
                  >
                    Export
                  </button>
                  <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                    Cancel
                  </button>
                </div>
              </div>
            </Popup>

            <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
              <AddToCart
                {...this.props}
                closeAddToCart={() => this.closeAddToCart()}
                cartViewDetailsId={this.state.cartViewDetails}
                cartViewType={this.state.cartViewType}
              />
            </Popup>
          </div>
        );
      }
    }
  }
}


